var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMyCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-my-cash_svg__a",
    x1: "79.928%",
    x2: "41.564%",
    y1: ".718%",
    y2: "111.28%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F8E24E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EEC42F"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "ic-my-cash_svg__b",
    cx: 16.354,
    cy: 16.028,
    rx: 15.693,
    ry: 15.58
  }), /*#__PURE__*/React.createElement("filter", {
    id: "ic-my-cash_svg__c",
    width: "121.4%",
    height: "121.6%",
    x: "-10.7%",
    y: "-10.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.929023172 0 0 0 0 0.739523436 0 0 0 0 0.208703971 0 0 0 1 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.094 1.094)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#ic-my-cash_svg__a)",
    xlinkHref: "#ic-my-cash_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ic-my-cash_svg__c)",
    xlinkHref: "#ic-my-cash_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#3B385E",
    strokeWidth: 1.728,
    xlinkHref: "#ic-my-cash_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B385E",
    fillRule: "nonzero",
    d: "M21.082 13.696a.313.313 0 00-.228-.087h-1.7a3.316 3.316 0 00-.636-1.4h2.316a.311.311 0 00.229-.087.295.295 0 00.089-.223v-.991a.298.298 0 00-.09-.224.313.313 0 00-.228-.087h-8.269a.315.315 0 00-.229.087.301.301 0 00-.089.224V12.2c0 .084.032.157.094.218a.31.31 0 00.224.093h1.441c1.398 0 2.286.366 2.664 1.098h-4.105a.315.315 0 00-.229.087.303.303 0 00-.089.224v.99c0 .092.03.166.09.224a.31.31 0 00.228.088h4.244c-.146.531-.485.936-1.019 1.214-.533.279-1.237.418-2.112.418h-1.113a.31.31 0 00-.224.093.297.297 0 00-.094.218V18.4c0 .085.03.156.09.214 1.272 1.322 2.921 3.171 4.949 5.549.06.078.142.116.248.116h1.938c.14 0 .236-.058.289-.175.066-.116.053-.226-.04-.33-1.935-2.32-3.455-4.055-4.562-5.208 1.127-.13 2.04-.486 2.743-1.07.703-.582 1.13-1.34 1.282-2.273h1.67c.093 0 .169-.03.228-.088a.296.296 0 00.09-.223v-.991c0-.09-.03-.165-.09-.224z"
  }))));
}
export default SvgIcMyCash;